import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

class RegulationsModalContent extends Component {
  render () {
    return (
      <div className='col-12 bg-white border-ui-3 radius-0 radius-md'>
        <div className='row border-bottom border-color-ui-3'>
          {/* <div className='col-12 px-3 py-3'>
            <h3>Termos de uso</h3>
          </div> */}
        </div>
        <div className='col-12 px-2 px-md-3 py-3' role='article'>
          {ReactHtmlParser(this.props.content)}
        </div>
      </div>
    )
  }
}

RegulationsModalContent.propTypes = {
  content: PropTypes.string
}

export default RegulationsModalContent



// WEBPACK FOOTER //
// ./src/features/RegulationModal/RegulationsModalContent.js